// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"d265681c","224":"08207397","328":"131d429a","615":"dcf8d925","655":"728e3713"}[chunkId] + ".css";
};